//
// Shared, variant-independent palette atoms for the v2 design language.
// Both `themeV2.js` and `themeVariants.js` import from here to avoid the
// circular dependency that would otherwise occur if themeV2 owned these
// constants AND consumed the active variant.
//

export const indigo = {
  50: '#EEF1FE',
  100: '#D6DCFB',
  200: '#A6B3F5',
  300: '#7E8EE9',
  400: '#6675D6',
  500: '#5C6BC0',
  600: '#4A4DA7',
  700: '#3D4B9C',
  800: '#2E3578',
  900: '#1E2552'
};

export const neutral = {
  50: '#FAFBFF',
  100: '#F3F5FA',
  200: '#E5E9F2',
  300: '#CDD3E1',
  400: '#9AA2B7',
  500: '#6B7390',
  600: '#4A5170',
  700: '#2F3552',
  800: '#1A1F36',
  900: '#0F1424'
};

export const yellow = {
  50: '#FFFDE7',
  100: '#FFF9C4',
  200: '#FFF59D',
  300: '#FFF176',
  400: '#FFEE58',
  500: '#FFEB3B',   // brand neoYellow
  600: '#FDD835',
  700: '#FBC02D',
  800: '#F9A825',
  900: '#F57F17'
};

// Surface tokens that don't change with the chosen variant. White-alpha
// values stay readable on either a black or a deep-indigo base.
export const sharedSurface = {
  divider: 'rgba(255, 255, 255, 0.08)',
  mutedText: 'rgba(255, 255, 255, 0.62)'
};

export const shadowsV2 = {
  xs: '0 1px 2px rgba(15, 20, 36, 0.06)',
  sm: '0 4px 12px rgba(15, 20, 36, 0.06)',
  md: '0 8px 24px rgba(15, 20, 36, 0.08)',
  lg: '0 20px 48px rgba(15, 20, 36, 0.12)',
  primary: '0 10px 24px rgba(92, 107, 192, 0.32)'
};
